import { useTranslation } from 'react-i18next';

import { GroupedCatalog } from '@/components/events/GroupedCatalog';

/**
 * Cities — `/eventos/ciudades`: el catálogo agrupado por ciudad.
 * Reemplaza el placeholder estático. Toda la lógica vive en `GroupedCatalog`.
 */
export function Cities(): JSX.Element {
  const { t } = useTranslation('events');
  return (
    <GroupedCatalog
      dimension="city"
      heading={t('grouped.citiesHeading')}
      subtitle={t('grouped.citiesSubtitle')}
      fallbackLabel={t('grouped.otherCities')}
    />
  );
}
